import React from 'react';
import { I18n } from '@aws-amplify/core';

import * as S from './styles';

import type { PostureImageConfig } from '@/components/views/Report/KimLhc/Report/Steps/Posture/Fields/BodyPostureOptions';

interface PostureDisplayProps {
	startLabel: string;
	endLabel: string;
	startImages: PostureImageConfig[];
	endImages: PostureImageConfig[];
}

function renderSingleImage(image: JSX.Element) {
	return <S.PostureImageWrapper>{image}</S.PostureImageWrapper>;
}

function renderImagesRow(images: JSX.Element[]) {
	return (
		<S.PostureImagesRow>
			{images.map((image, idx) => (
				<React.Fragment key={idx}>
					{idx > 0 && <S.PostureRowDivider imageCount={images.length} />}
					<S.PostureImageWrapperSmall>{image}</S.PostureImageWrapperSmall>
				</React.Fragment>
			))}
		</S.PostureImagesRow>
	);
}

function renderImagesGrid(images: JSX.Element[]) {
	return (
		<S.PostureImagesGrid>
			{images.map((image, idx) => (
				<S.PostureImageWrapperSmall key={idx}>{image}</S.PostureImageWrapperSmall>
			))}
			<S.PostureGridDividers />
		</S.PostureImagesGrid>
	);
}

function renderPostureColumn(imageConfigs: PostureImageConfig[]) {
	const images = imageConfigs.map((cfg) => <cfg.component key={cfg.key} />);
	if (images.length === 4) return renderImagesGrid(images);
	if (images.length > 1) return renderImagesRow(images);

	return renderSingleImage(images[0]);
}

export function PostureDisplayCard({ startLabel, endLabel, startImages, endImages }: Readonly<PostureDisplayProps>): JSX.Element {
	return (
		<>
			<S.PostureColumn>
				<S.PostureLabel>{I18n.get(startLabel)}</S.PostureLabel>
				{renderPostureColumn(startImages)}
			</S.PostureColumn>
			<S.PostureDivider />
			<S.PostureColumn>
				<S.PostureLabel>{I18n.get(endLabel)}</S.PostureLabel>
				{renderPostureColumn(endImages)}
			</S.PostureColumn>
		</>
	);
}

export function PostureDisplayModal({ startLabel, endLabel, startImages, endImages }: Readonly<PostureDisplayProps>): JSX.Element {
	return (
		<>
			<S.ModalColumn>
				<S.ModalColumnLabel>{I18n.get(startLabel)}</S.ModalColumnLabel>
				{renderPostureColumn(startImages)}
			</S.ModalColumn>
			<S.ModalDivider />
			<S.ModalColumn>
				<S.ModalColumnLabel>{I18n.get(endLabel)}</S.ModalColumnLabel>
				{renderPostureColumn(endImages)}
			</S.ModalColumn>
		</>
	);
}
